<template>
  <div class="paysuspage">
    <div class="">
      <div class="paysusicon" v-show="getChargeState(1)">
        <img src="../../assets/images/sus.png" alt class="payicon">
        <span>缴费成功！</span>
      </div>
      <div class="paysusicon" v-show="getChargeState(2)">
        <img src="../../assets/images/失败.png" alt class="payicon">
        <span>缴费失败！</span>
      </div>
      <div class="paysusicon" v-show="getChargeState(0)">
        <img src="../../assets/images/查询.png" alt class="payicon">
        <span>缴费确认中...</span>
      </div>
      <div class="paylistsus">
        <span class="listline"></span>
        <p class="paylisttit">
          <span class="title">缴费信息</span>
        </p>
        <div class="payliscon">
          <p>
            <span>流水号：</span>
            <span>{{charegeInfo.ChargeNo}}</span>
          </p>
          <p>
            <span>收费金额：</span>
            <span>{{charegeInfo.Amount}}</span>
          </p>
          <p>
            <span>支付时间：</span>
            <span>{{charegeInfo.ChargeTime}}</span>
          </p>
          <p>
            <span>就诊医生：</span>
            <span>{{charegeInfo.DctName}}</span>
          </p>
        </div>
      </div>

       <!-- <div class="paylistsus">
        <span class="listline"></span>
        <p class="paylisttit">
          <span class="title">缴费信息</span>
        </p>
        <div class="payliscon">
          <p>
            <span>流水号：</span>
            <span>2023121200033</span>
          </p>
          <p>
            <span>收费金额：</span>
            <span>666</span>
          </p>
          <p>
            <span>支付时间：</span>
            <span>2023-12-15 14:33:00</span>
          </p>
          <p>
            <span>就诊医生：</span>
            <span>云龙</span>
          </p>
        </div>
      </div> -->


      <div class="drugdeteil" v-for="(item, index) in charegeInfo.Detail" :key="index">
        <span class="listline"></span>
        <p class="paylisttit">
          <span>{{item.Name}}</span>
        </p>
        <div class="payliscon">
          <div class="Clinicguide">
            <p>
              <span>就诊指引：</span>
              <span>{{item.Address}}</span>
            </p>
            <p>
              <span>处方号：</span>
              <span>{{item.OrderNumber}}</span>
            </p>
          </div>
          <div class="drug">
            <p class="bg">
              <span>项目名称</span>
              <span>数量</span>
              <span>总价</span>
            </p>
            <p v-for="(model, index) in item.Detail" :key="index">
              <span>{{model.Name}}</span>
              <span>{{model.Quantity}}</span>
              <span>{{model.Amount}}</span>
            </p>
            <div class="amount">
              <span>小计：</span>
              <span></span>
              {{item.Amount}}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="surebnt" @click="bankhome">
      <span class="mr20">返回首页</span>
    </div>
  </div>
</template>
<script>
  import { ChargeSuccess, QueryOrderState } from "@/services/getData.js";
  import weui from "weui.js";
  export default {
    name: "outpatient-paysus",
    data() {
      return {
        chargeID: this.$route.query.chargeID,
        charegeInfo: [],
        returnState: 0,
        outOrder: this.$route.query.outOrder
      };
    },
    created: function () {
      this.chargeSuccess();
    },
    methods: {
      bankhome() {
        //返回首页
        this.$router.push({ path: "/", params: {} });
      },
      chargeSuccess() {
        var loading = weui.loading("loading", {
          className: "custom-classname",
          content: "加载中"
        });
        if (this.chargeID) {
          var loading = weui.loading("loading", {
            className: "custom-classname",
            content: "加载中"
          });
          ChargeSuccess(this.chargeID).then(response => {
            loading.hide();
            this.returnState = 1;
            this.charegeInfo = response.data;
          });
        } else {
          QueryOrderState(this.outOrder, 5)
            .then(response => {
              //loading.hide();
              this.returnState = 1;
              var loading = weui.loading("loading", {
                className: "custom-classname",
                content: "加载中"
              });
              ChargeSuccess(response.data.Extend).then(response => {
                loading.hide();
                this.charegeInfo = response.data;
              });
            })
            .catch(err => {
              loading.hide();
              this.returnState = 2;
            });
        }
      },
      getChargeState(state) {
        if (state == this.returnState) {
          return true;
        } else {
          return false;
        }
      }
    }
  };
</script>

<style>
  .paysuspage {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

    .paysuspage .flex {
      flex: 1;
    }

    .paysuspage .paysusicon {
      width: 100%;
      height: 2.2rem;
      background: white;
      text-align: center;
      box-sizing: border-box;
      padding: 0.32rem 0;
      font-size: 0.3rem;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      margin-bottom: 0.2rem;
    }

      .paysuspage .paysusicon .payicon {
        width: 1.02rem;
        height: 1.07rem;
        margin: 0 auto;
        margin-bottom: 0.1rem;
      }

    .paysuspage .paylistsus {
      /* padding: 0 0.2rem; */
      box-sizing: border-box;
      width: 100%;
      height: auto;
      background-color: white;
      position: relative;
      margin-bottom: 0.2rem;
    }

    .paysuspage .paylisttit {
      font-size: 0.26rem;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #1592e4;
      border-bottom: 0.01rem solid #dddddd;
      height: 0.79rem;
      line-height: 0.8rem;
      padding-left: 0.2rem;
      box-sizing: border-box;
      width: 100%;
    }

    .paysuspage .payliscon {
      width: 100%;
      box-sizing: border-box;
      padding: 0 0.2rem;
    }

    .paysuspage .Clinicguide {
      font-family: MicrosoftYaHei;
      font-weight: 400;
      font-size: 0.22rem;
      padding-top: 0.2rem;
      box-sizing: border-bo;
    }

    .paysuspage .paylistsus > .payliscon > p {
      width: 100%;
      border-bottom: 0.01rem dotted #dddddd;
      height: 0.79rem;
      line-height: 0.8rem;
      font-size: 0.26rem;
      font-family: MicrosoftYaHei;
      font-weight: 400;
    }

      .paysuspage .paylistsus > .payliscon > p > span:first {
        color: #333333;
        text-align: left;
      }

      .paysuspage .paylistsus > .payliscon > p > span:last-child {
        color: #999999;
        text-align: right;
        float: right;
      }

      .paysuspage .paylistsus > .payliscon > p:last-child {
        border-bottom: none;
      }

    .paysuspage .listline {
      display: block;
      position: absolute;
      width: 0.08rem;
      height: 0.8rem;
      background: rgba(21, 146, 228, 1);
      top: 0;
      left: 0;
    }

    .paysuspage .drugdeteil {
      font-size: 0.2rem;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      background: white;
      position: relative;
      margin-bottom: 0.2rem;
    }

      .paysuspage .drugdeteil .drug {
        border: 0.01rem solid #dddddd;
        margin: 0.2rem 0;
      }

        .paysuspage .drugdeteil .drug > p {
          display: flex;
          flex-direction: row;
          line-height: 0.35rem;
          margin-bottom: 0.21rem;
        }

          .paysuspage .drugdeteil .drug > p > span:first-child {
            width: 60%;
            box-sizing: border-box;
            padding-left: 0.43rem;
          }

          .paysuspage .drugdeteil .drug > p > span:nth-child(2) {
            width: 20%;
          }

          .paysuspage .drugdeteil .drug > p > span:last-child {
            width: 20%;
            text-align: center;
          }

        .paysuspage .drugdeteil .drug .amount {
          text-align: right !important;
          color: red;
          box-sizing: border-box;
          padding-right: 0.25rem;
          border-top: 0.01rem solid #dddddd;
          line-height: 0.6rem;
        }

        .paysuspage .drugdeteil .drug .bg {
          background: #f2f2f2;
          height: 0.6rem;
          line-height: 0.6rem;
        }

    .paysuspage .surebnt {
      height: 0.8rem;
      margin: 0.2rem;
      font-family: "MicrosoftYaHei";
      font-size: 0.26rem;
      background-color: #1592e4;
      color: white;
      text-align: center;
      line-height: 0.8rem;
      margin-top: 0.3rem;
    }
</style>




// WEBPACK FOOTER //
// src/components/outpatientpay/outpatient-paysus.vue